import React from 'react';
import ReactDOM  from 'react-dom';

import { useNpsSingleSelect } from './hooks'

import axios from 'axios';

import { AiFillCloseCircle } from "react-icons/ai";
import { IconContext } from "react-icons";

import {
    Container,
    Header,
    TitleHeader,
    CloseButtonHeader,
    Content
} from './styles';

interface IModalProps {
    isModalVisible: boolean;
    hideModal: () => void;
    codDeal : string;
}


function translateNPS(nps : String) {
    switch (nps) {
        case '0':
            return '3327'
        case '1':
            return '78'
        case '2':
            return '80'
        case '3':
            return '82'
        case '4':
            return '84'
        case '5':
            return '86'
        case '6':
            return '88'
        case '7':
            return '90'
        case '8':
            return '92'
        case '9':
            return '94'
        case '10':
            return '96'
        default:
            break;
    }
}

const RespNpsModal : React.FC<IModalProps> = ({
    codDeal,
    hideModal,
    isModalVisible
}) => {

    const npsArray = ["10", "9", "8", "7", "6", "5", "4", "3", "2", "1", "0"];
    const { selectedNps, isSelectedNps, onChangeNps } = useNpsSingleSelect(["10"]);

    const submitForm = () => {
        handleAddNps();
        hideModal();
    }

    const handleAddNps = () => {

        axios.post('https://niatech.bitrix24.com.br/rest/1/9cwjchlqktog52yq/crm.deal.update', {
            "id": codDeal,
            "fields": {
                "UF_CRM_1622639662" : translateNPS(String(selectedNps))
            }
        }).then(response => {
            })
            .catch(e => {})
    }

    const modal = (
        <Container>
            <Header>
                <TitleHeader>
                    Resposta NPS
                </TitleHeader>
                <CloseButtonHeader onClick={hideModal}>
                    <IconContext.Provider value={{ color: 'black', size: '25px' }}>
                        <AiFillCloseCircle />
                    </IconContext.Provider>
                </CloseButtonHeader>
            </Header>
            <Content>
                <h4>Avaliação:</h4>
                <ul style={{ listStyleType: "none" }}>
                    {npsArray.map((value) => (
                        <li key={value}>
                        <input
                            id={value}
                            type="checkbox"
                            value={value}
                            checked={isSelectedNps(value)}
                            onChange={onChangeNps}
                            required
                        />
                        <label htmlFor={value}>{value}</label>
                        </li>
                    ))}
                </ul>
                <button onClick={submitForm}>Enviar</button>
            </Content>
        </Container>
    )

    return isModalVisible ? ReactDOM.createPortal(modal, document.body) : null;
}

export default RespNpsModal;